// Registry of reward-calculation types. Add a new type by appending a definition here.
import type { RewardCalculationTypeDefinition } from '../types'
import { helpKey } from '../../help'
import { RewardCalculationType, type ScoreRangeRewardCalculationTypeModel } from './types'
import FixedRewardEditor from '@/pages/action-modules/editor/reward-tab/types/FixedRewardEditor'
import ScoreMultiplyRewardEditor from '@/pages/action-modules/editor/reward-tab/types/ScoreMultiplyRewardEditor'
import ScoreRangeRewardEditor from '@/pages/action-modules/editor/reward-tab/types/ScoreRangeRewardEditor'

export const rewardCalculationTypes: RewardCalculationTypeDefinition[] = [
  {
    nameKey: 'rewardCalculationType.fixed.name',
    helpKey: helpKey('rewardFixed'),
    type: RewardCalculationType.FixedRewardCalculationType,
    defaultValue: { reward: 10 },
    editor: props => <FixedRewardEditor {...props} />,
  },
  {
    nameKey: 'rewardCalculationType.manualInput.name',
    helpKey: helpKey('rewardManualInput'),
    type: RewardCalculationType.ManualInputCalculationType,
    defaultValue: {},
    // Nothing to configure — the reward tab renders `helpKey` on its own.
    editor: () => null,
  },
  {
    nameKey: 'rewardCalculationType.maxPoints.name',
    helpKey: helpKey('rewardMaxPoints'),
    type: RewardCalculationType.MaxPointsCalculationType,
    defaultValue: {},
    editor: () => null,
  },
  {
    nameKey: 'rewardCalculationType.percentMaxPoints.name',
    helpKey: helpKey('rewardPercentMaxPoints'),
    type: RewardCalculationType.PercentMaxPointsCalculationType,
    defaultValue: {},
    editor: () => null,
  },
  {
    nameKey: 'rewardCalculationType.scoreMultiply.name',
    helpKey: helpKey('rewardScoreMultiply'),
    type: RewardCalculationType.ScoreMultiplyRewardCalculationType,
    defaultValue: { factor: 2 },
    editor: props => <ScoreMultiplyRewardEditor {...props} />,
  },
  {
    nameKey: 'rewardCalculationType.scoreRange.name',
    helpKey: helpKey('rewardScoreRange'),
    type: RewardCalculationType.ScoreRangeCalculationType,
    defaultValue: {
      scoreRanges: [
        { scoreFrom: 0, scoreTo: 5, pointsRewarded: 5 },
        { scoreFrom: 5, scoreTo: 10, pointsRewarded: 4 },
        { scoreFrom: 10, scoreTo: 15, pointsRewarded: 3 },
        { scoreFrom: 15, scoreTo: 20, pointsRewarded: 2 },
        { scoreFrom: 20, scoreTo: 25, pointsRewarded: 1 },
        { scoreFrom: 25, scoreTo: 30, pointsRewarded: 0 },
      ],
    } as ScoreRangeRewardCalculationTypeModel,
    editor: props => <ScoreRangeRewardEditor {...props} />,
  },
  {
    nameKey: 'rewardCalculationType.splitMaxPoints.name',
    helpKey: helpKey('rewardSplitMaxPoints'),
    type: RewardCalculationType.SplitMaxPointsCalculationType,
    defaultValue: {},
    editor: () => null,
  },
]
